import { forEach, orderBy } from 'lodash';

import CoreUtils from '../../common/utils/CoreUtils';
import StringUtils from '../../common/utils/StringUtils';

import ScheduleDataModel from '../../schedules/ScheduleDataModel';

import EnergyValue from '../../common/value-types/EnergyValue';

const aggregationRoleKey = 'AggregationRole';
const datacenterAssignmentKey = 'DatacenterAssignment';

const aggregationRole_NoneRole      = 'NONE';
const aggregationRole_InputRole     = 'INPUT';
const aggregationRole_SummationRole = 'SUM';
const aggregationRole_AverageRole   = 'AVG';
const aggregationRole_MaximumRole   = 'MAX';
const aggregationRole_MinimumRole   = 'MIN';

export default class AggregableDataModel extends ScheduleDataModel {
  constructor(locale, counterparty, commandDataModel, summaryDataModel) {
    super(locale, counterparty, commandDataModel)

    this.summaryDataModel = summaryDataModel;

    this.inputContracts = [];
    this.aggregatedContracts = [];
  }

  processContracts(scheduleUpdateDto) {
    this.inputContracts = [];
    this.aggregatedContracts = [];

    forEach(scheduleUpdateDto.contracts, contractDto => {

      var contract = {};
      Object.assign(contract, contractDto);

      this.registerContract(contract);

      if (contract.parameters[aggregationRoleKey] === aggregationRole_InputRole)
        this.inputContracts.push(contract);
      else if (contract.parameters[aggregationRoleKey] !== aggregationRole_NoneRole)
        this.aggregatedContracts.push(contract);
    });
  }

  getDefaultSortCriteria() {
    return {
      fields: ['localDateMs', 'contractCode'],
      order: ['asc', 'asc']
    };
  }

  updateOverallStatus() {
    super.updateOverallStatus();

    CoreUtils.iterateProperties(this.indexedContracts, (_, contract) => {
    });

    CoreUtils.iterateProperties(this.indexedSchedules, (_, schedule) => {
      var contract = this.indexedContracts[schedule.contractCode];
      if (contract === undefined)
        return;
    });

    if (CoreUtils.isDefinedAndNotNull(this.summaryDataModel)) {
      var contracts = [];
      CoreUtils.iterateProperties(this.indexedContracts, (_, contract) => {
        if (this.currentDatacenterFilter === null
          || contract.parameters[datacenterAssignmentKey] === this.currentDatacenterFilter
          || StringUtils.isEmptyString(contract.parameters[datacenterAssignmentKey]))
          contracts.push(contract);
      });

      this.summaryDataModel.updateProperties({
        contracts: orderBy(contracts, ['code'], ['asc'])
      });
    }

    this.hasValidationErrors = false;

    if (CoreUtils.isDefinedAndNotNull(this.commandDataModel)) {
      this.commandDataModel.updateProperties({
        hasValidationErrors: this.hasValidationErrors
      });
    }
  }

  onScheduleUpdated(schedule, isServerUpdate, isPeerUpdate, updatedDataFields, quickEntryHints) {
    super.onScheduleUpdated(schedule, isServerUpdate, isPeerUpdate, updatedDataFields, quickEntryHints);

    this.updateAggregatedContracts(schedule, updatedDataFields, isServerUpdate, isPeerUpdate);
  }

  onFieldValuesEditing(schedule, dataFieldValues) {
    if (!super.onFieldValuesEditing(schedule, dataFieldValues))
      return false;

    return this.filterUpdatingElectableHourFields(
      schedule,
      dataFieldValues,
      this.indexedContracts[schedule.contractCode]
    );
  }

  updateScheduleUsage(schedule, updatedDataFields) {
    super.updateScheduleUsage(schedule, updatedDataFields);

    var totalMWh = 0;
    var totalH = 0;

    forEach(
      schedule.hourlyDataFields, dataField => {
        totalMWh += schedule[dataField].averageValue;
        totalH += schedule[dataField].averageDuration;
      }
    );

    if (totalMWh !== schedule.totalMWh) {
      schedule.totalMWh = totalMWh;
      updatedDataFields.push('totalMWh');
    }

    if (totalH !== schedule.totalH) {
      schedule.totalH = totalH;
      updatedDataFields.push('totalH');
    }
  }

  updateAggregatedContracts(schedule, updatedDataFields, isServerUpdate, isPeerUpdate) {
    if (isServerUpdate || this.aggregatedContracts.length === 0)
      return;

    var contract = this.resolveContract(schedule.contractCode);
    var role = contract.parameters[aggregationRoleKey];

    if (role !== aggregationRole_InputRole)
      return;

    var inputSchedules = this.inputContracts.map(
      inputContract => this.getRelatedSchedule(schedule, inputContract)
    );

    var aggregatedSchedules = this.aggregatedContracts.map(
      aggregatedContract => this.getRelatedSchedule(schedule, aggregatedContract)
    );

    var scheduleUpdateSets = [];

    aggregatedSchedules.forEach((aggregatedSchedule, scheduleIndex) => {
      if (CoreUtils.isUndefinedOrNull(aggregatedSchedule))
        return;

      var aggregatedContract = this.aggregatedContracts[scheduleIndex];
      var aggregatedRole = aggregatedContract.parameters[aggregationRoleKey];

      var updatedValues = {};
      updatedDataFields.forEach(dataField => {
        if (aggregatedSchedule.hourlyDataFields.indexOf(dataField) === -1)
          return;

        var sourceValues = inputSchedules.map(inputSchedule => inputSchedule[dataField]);
        updatedValues[dataField] = AggregableDataModel.computeHourValue(
          sourceValues,
          aggregatedContract.subhourlyResolution,
          aggregatedRole
        );
      });

      scheduleUpdateSets.push({
        scheduleId: aggregatedSchedule.scheduleId,
        values: updatedValues
      });
    });

    this.updateSchedules(scheduleUpdateSets, false);
  }

  static computeHourValue(sourceValues, subhourlyResolution, contractRole) {
    switch (contractRole) {
      case aggregationRole_SummationRole:
        return EnergyValue.sum(sourceValues, subhourlyResolution);
      case aggregationRole_AverageRole:
        return EnergyValue.average(sourceValues, subhourlyResolution);
      case aggregationRole_MinimumRole:
        return EnergyValue.minimum(sourceValues, subhourlyResolution);
      case aggregationRole_MaximumRole:
        return EnergyValue.maximum(sourceValues, subhourlyResolution);
      default:
        return new EnergyValue();
    }
  }
}